/*
 * note: i18n by nuxt-i18n i18nの不具合があればこのファイルから参照する
 * ref: https://v8.i18n.nuxtjs.org/
 *
 * 社内管理ツールのため日本語(ja)固定で運用する。
 * - strategy: 'no_prefix' … URL に /ja /en のロケールprefixを付けない
 * - detectBrowserLanguage: false … ブラウザ言語による自動リダイレクトをしない
 * - defaultLocale / locale は ja 固定
 * 英語(en)はロケール定義・メッセージとして残置している(型互換のため。
 * URL/自動切替には現れない)。
 * en.json は凍結済み。文言の追加・保守は ja.json のみ行う(社内ツールのため)。
 */
import type { NuxtI18nOptions } from '@nuxtjs/i18n'
import en from './locales/en.json'
import ja from './locales/ja.json'

const jaLanguage = 'ja'
const enLanguage = 'en'

// settings for nuxt-i18n v9~
export const nuxtI18nOptions: NuxtI18nOptions = {
  strategy: 'no_prefix',
  locales: [
    {
      code: jaLanguage,
      language: 'ja-JP',
      file: 'ja.json',
      isCatchallLocale: true,
    },
    {
      code: enLanguage,
      language: 'en-US',
      file: 'en.json',
    },
  ],
  defaultLocale: jaLanguage,
  customRoutes: 'config',
  pages: {
    api: false,
    server: false,
  },
  detectBrowserLanguage: false,
  vueI18n: '#main/i18n/i18n.config.ts',
}

export default {
  legacy: false,
  locale: jaLanguage,
  messages: {
    ja,
    en,
  },
}
